<script>
	export let def = 'svg_pin';
	export let viewbox = '0 0 128 128';
	export let css = '';
	export let rot = '0';
	export let style = '';
</script>

<style>
	svg {
		fill: currentColor;
	}
</style>

<svg class="{css}" style="transform:rotate({rot}deg); {style}" viewBox={viewbox}><use xlink:href="#{def}"/></svg>